// Client-side image compression — community uploads get resized + re-encoded to webp
// in the browser so a 12MB phone photo uploads as ~1MB. Anything already small is sent as-is.
export async function compressImage(file, maxDim = 3000, quality = 0.88) {
  if (file.size <= 1500 * 1024) return file;
  // camera RAW/HEIC/TIFF files can't be decoded by most browsers — server converts them instead
  if (/\.(heic|heif|cr2|cr3|dng|tiff?)$/i.test(file.name)) return file;
  try {
    const bitmap = await createImageBitmap(file);
    let { width, height } = bitmap;
    if (Math.max(width, height) > maxDim) {
      const scale = maxDim / Math.max(width, height);
      width = Math.round(width * scale);
      height = Math.round(height * scale);
    }
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    canvas.getContext("2d").drawImage(bitmap, 0, 0, width, height);
    bitmap.close?.();
    const blob = await new Promise((res) => canvas.toBlob(res, "image/webp", quality));
    if (!blob || blob.size >= file.size) return file;
    const name = file.name.replace(/\.[^.]+$/, "") + ".webp";
    return new File([blob], name, { type: "image/webp" });
  } catch {
    return file; // never block an upload because compression failed
  }
}
